"use client";

import { SelectedFilterCount } from "@/components/common/selected-filter-count";
import { businessFiltersAtom } from "@/app/(saas)/(app)/businesses/_components/filters/state";
import { BusinessTypeFilter } from "@/app/(saas)/(app)/businesses/_components/filters/type-filter";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useAtom } from "jotai";
import { useTranslations } from "next-intl";

export function BusinessTypeFilterPopover() {
  const t = useTranslations();

  const [filters] = useAtom(businessFiltersAtom);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="min-w-0 h-full justify-between">
          <div className="flex items-center gap-2 min-w-0">
            {filters.businessTypeIds.length > 0 && (
              <SelectedFilterCount count={filters.businessTypeIds.length} />
            )}

            <span className="overflow-hidden text-ellipsis">
              {t("saas.search.filters.fields.businessTypes.label")}
            </span>
          </div>

          <Icon icon="ChevronDown" />
        </Button>
      </PopoverTrigger>

      <PopoverContent
        align="start"
        className="relative w-[416px] overflow-hidden rounded-xl p-0"
      >
        <BusinessTypeFilter />
      </PopoverContent>
    </Popover>
  );
}
